import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { PageHeader } from "@/components/common/PageHeader";
import { EmptyState } from "@/components/common/EmptyState";
import { SurfaceCard } from "@/components/common/Cards";
import { StatusBadge } from "@/components/common/StatusBadge";
import { initials, relativeDay } from "@/lib/format";
import { Syringe, ChevronRight } from "lucide-react";

export default function Surgeries() {
  const navigate = useNavigate();
  const [items, setItems] = useState(null);
  useEffect(() => {
    api.get("/cases").then((r) => {
      const surg = r.data.filter((c) => c.stage === "surgery" || (c.stages_done || []).includes("surgery"));
      setItems(surg);
    }).catch(() => setItems([]));
  }, []);

  return (
    <div>
      <PageHeader title="Surgeries" subtitle="Scheduled and completed implant surgeries" breadcrumb={["Practice", "Surgeries"]} />
      {items && items.length === 0 ? (
        <EmptyState icon={Syringe} title="No surgeries scheduled" description="Cases that reach the surgery stage will appear here." testId="surgeries-empty" />
      ) : (
        <div className="space-y-3">
          {(items || []).map((c) => (
            <SurfaceCard key={c.id} className="p-4 cursor-pointer hover:border-[#00A85A]/40" onClick={() => navigate(`/cases/${c.id}`)}>
              <div className="flex items-center gap-4">
                <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-[#E8F7F0] dark:bg-[#00A85A]/15"><Syringe className="h-5 w-5 text-[#00A85A]" /></div>
                <div className="flex-1 min-w-0"><div className="text-sm font-bold text-[#101516] dark:text-white truncate">{c.patient_name} · {c.title}</div><div className="text-xs text-[#8B9698]">{c.treatment} · Tooth {c.implant_site?.tooth || "—"}</div></div>
                <StatusBadge status={c.readiness === 100 ? "completed" : "in_progress"} label={c.readiness === 100 ? "Completed" : "Scheduled"} />
                <ChevronRight className="h-4 w-4 text-[#8B9698]" />
              </div>
            </SurfaceCard>
          ))}
        </div>
      )}
    </div>
  );
}
